import Api from './ApiRequest';

export default {
    getById: (id) => Api.get('/cent/address/' + id, null),
    save: (entity) => Api.post('/cent/address', entity),
    update: (id, entity) => Api.put('/cent/address/' + id, entity),
    getStats: () => Api.get('/cent/addresses/stats', null),
};